<!-- Offerta Section -->
<section class="offerta-section" [@fadeInDown]="{ value: '', params: { delay: 100 } }">
  <div class="container">
    <div class="text-center mb-5" >
      <h2 class="font-4xl font-bold">Offerta</h2>
      <div class="divider-line mx-auto"></div>
      <p class="text-muted mt-3 mb-0">Ogni piano è un percorso.<br />Clicca sulle card per scoprire nel dettaglio cosa include ogni servizio.</p>
    </div>
    
    <div class="row g-4" [@fadeInDown]="{ value: '', params: { delay: 200 } }">
      <!-- FREE Card -->
      <div class="col-lg-3 col-md-6">
        <div class="offerta-card offerta-card-free p-5 position-relative" (click)="openFreeOffer()">
          <h3 class="text-black fw-bold fs-2 mb-3">FREE</h3>
          <p class="text-black font-lg mb-0">
            Il primo passo verso la consapevolezza finanziaria
          </p>
          <div class="offer-card-dots">
            <span class="offer-dot offer-dot-filled" aria-hidden="true"></span>
            <span class="offer-dot offer-dot-empty" aria-hidden="true"></span>
            <span class="offer-dot offer-dot-empty" aria-hidden="true"></span>
          </div>
        </div>
      </div>

      <!-- SILVER Card -->
      <div class="col-lg-3 col-md-6">
        <div class="offerta-card offerta-card-silver p-5 position-relative" (click)="openSilverOffer()">
          <h3 class="text-black fw-bold fs-2 mb-3">SILVER</h3>
          <p class="text-black font-lg mb-0">
            Ideale per chi vuole iniziare a strutturarsi
          </p>
          <div class="offer-card-dots">
            <span class="offer-dot offer-dot-filled" aria-hidden="true"></span>
            <span class="offer-dot offer-dot-empty" aria-hidden="true"></span>
            <span class="offer-dot offer-dot-empty" aria-hidden="true"></span>
          </div>
        </div>
      </div>

      <!-- GOLD Card -->
      <div class="col-lg-3 col-md-6">
        <div class="offerta-card offerta-card-gold p-5 position-relative" (click)="openGoldOffer()">
          <h3 class="text-black fw-bold fs-2 mb-3">GOLD</h3>
          <p class="text-black font-lg mb-0">
            Per chi vuole dati, velocità e strumenti operativi
          </p>
          <div class="offer-card-dots">
            <span class="offer-dot offer-dot-filled" aria-hidden="true"></span>
            <span class="offer-dot offer-dot-empty" aria-hidden="true"></span>
            <span class="offer-dot offer-dot-empty" aria-hidden="true"></span>
          </div>
        </div>
      </div>

      <!-- PLATINO Card -->
      <div class="col-lg-3 col-md-6">
        <div class="offerta-card offerta-card-platino p-5 position-relative" (click)="openPlatinoOffer()">
          <h3 class="text-black fw-bold fs-2 mb-3">PLATINO</h3>
          <p class="text-black font-lg mb-0">
            Il massimo livello, per chi vuole un percorso su misura
          </p>
          <div class="offer-card-dots">
            <span class="offer-dot offer-dot-filled" aria-hidden="true"></span>
            <span class="offer-dot offer-dot-empty" aria-hidden="true"></span>
            <span class="offer-dot offer-dot-empty" aria-hidden="true"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Templates per le storie Instagram-style (nascosti) -->

<!-- FREE Templates -->
<ng-template #freeStory1>
  <div class="story-content text-center p-5">
    <div class="story-icon mb-4">
      <i class="fas fa-seedling fa-5x text-success"></i>
    </div>
    <h2 class="fw-bold mb-4">Piano FREE</h2>
    <p class="fs-3 mb-3">Il primo passo verso la consapevolezza finanziaria</p>
    <p class="fs-4 text-white-50">Inizia gratuitamente il tuo percorso</p>
  </div>
</ng-template>

<ng-template #freeStory2>
  <div class="story-content text-center p-5">
    <div class="story-icon mb-4">
      <i class="fas fa-check-circle fa-3x text-success mb-4"></i>
    </div>
    <h3 class="fw-bold fs-2 mb-4">Cosa include:</h3>
    <ul class="list-unstyled fs-4 text-start" style="max-width: 600px; margin: 0 auto;">
      <li class="mb-3"><i class="fas fa-check text-success me-3"></i>Accesso ai contenuti educativi base</li>
      <li class="mb-3"><i class="fas fa-check text-success me-3"></i>Newsletter settimanale</li>
      <li class="mb-3"><i class="fas fa-check text-success me-3"></i>Community di supporto</li>
      <li class="mb-3"><i class="fas fa-check text-success me-3"></i>Webinar mensili gratuiti</li>
    </ul>
  </div>
</ng-template>

<ng-template #freeStory3>
  <div class="story-content text-center p-5">
    <div class="story-icon mb-4">
      <i class="fas fa-rocket fa-5x text-warning"></i>
    </div>
    <h2 class="fw-bold mb-4">Inizia Subito!</h2>
    <p class="fs-3 mb-5">Registrati gratuitamente e inizia il tuo percorso</p>
    @if (!(isMaintenanceMode$ | async)) {
      <button class="btn btn-light btn-lg px-5 py-3 fs-4">
        <i class="fas fa-user-plus me-2"></i>Registrati Gratis
      </button>
    }
  </div>
</ng-template>

<!-- SILVER Templates -->
<ng-template #silverStory1>
  <div class="story-content text-center p-5">
    <div class="story-icon mb-4">
      <i class="fas fa-medal fa-5x" style="color: #C0C0C0;"></i>
    </div>
    <h2 class="fw-bold mb-4">Piano SILVER</h2>
    <p class="fs-3 mb-3">Ideale per chi vuole iniziare a strutturarsi</p>
    <p class="fs-4 text-white-50">Strumenti professionali per crescere</p>
  </div>
</ng-template>

<ng-template #silverStory2>
  <div class="story-content text-center p-5">
    <div class="story-icon mb-4">
      <i class="fas fa-star fa-3x text-warning mb-4"></i>
    </div>
    <h3 class="fw-bold fs-2 mb-4">Cosa include:</h3>
    <ul class="list-unstyled fs-4 text-start" style="max-width: 600px; margin: 0 auto;">
      <li class="mb-3"><i class="fas fa-check text-warning me-3"></i>Tutto del piano FREE</li>
      <li class="mb-3"><i class="fas fa-check text-warning me-3"></i>Corsi avanzati di educazione finanziaria</li>
      <li class="mb-3"><i class="fas fa-check text-warning me-3"></i>Strumenti di analisi base</li>
      <li class="mb-3"><i class="fas fa-check text-warning me-3"></i>Report mensili personalizzati</li>
      <li class="mb-3"><i class="fas fa-check text-warning me-3"></i>Supporto via email prioritario</li>
    </ul>
  </div>
</ng-template>

<ng-template #silverStory3>
  <div class="story-content text-center p-5">
    <div class="story-icon mb-4">
      <i class="fas fa-trophy fa-5x text-warning"></i>
    </div>
    <h2 class="fw-bold mb-4">Investi in Te Stesso</h2>
    <p class="fs-3 mb-3">Piano SILVER</p>
    <p class="fs-2 font-bold mb-5">€49/mese</p>
    <button class="btn btn-light btn-lg px-5 py-3 fs-4">
      <i class="fas fa-arrow-right me-2"></i>Scopri di Più
    </button>
  </div>
</ng-template>

<!-- GOLD Templates -->
<ng-template #goldStory1>
  <div class="story-content text-center p-5">
    <div class="story-icon mb-4">
      <i class="fas fa-crown fa-5x text-warning"></i>
    </div>
    <h2 class="fw-bold mb-4">Piano GOLD</h2>
    <p class="fs-3 mb-3">Per chi vuole dati, velocità e strumenti operativi</p>
    <p class="fs-4 text-white-50">Il livello professionale</p>
  </div>
</ng-template>

<ng-template #goldStory2>
  <div class="story-content text-center p-5">
    <div class="story-icon mb-4">
      <i class="fas fa-gem fa-3x text-warning mb-4"></i>
    </div>
    <h3 class="fw-bold fs-2 mb-4">Cosa include:</h3>
    <ul class="list-unstyled fs-4 text-start" style="max-width: 600px; margin: 0 auto;">
      <li class="mb-3"><i class="fas fa-check text-warning me-3"></i>Tutto del piano SILVER</li>
      <li class="mb-3"><i class="fas fa-check text-warning me-3"></i>Strumenti operativi avanzati</li>
      <li class="mb-3"><i class="fas fa-check text-warning me-3"></i>Dati in tempo reale</li>
      <li class="mb-3"><i class="fas fa-check text-warning me-3"></i>Analisi predittive e algoritmi</li>
      <li class="mb-3"><i class="fas fa-check text-warning me-3"></i>API per integrazione</li>
      <li class="mb-3"><i class="fas fa-check text-warning me-3"></i>Supporto telefonico prioritario</li>
    </ul>
  </div>
</ng-template>

<ng-template #goldStory3>
  <div class="story-content text-center p-5">
    <div class="story-icon mb-4">
      <i class="fas fa-chart-line fa-5x text-success"></i>
    </div>
    <h2 class="fw-bold mb-4">Massimizza il Potenziale</h2>
    <p class="fs-3 mb-3">Piano GOLD</p>
    <p class="fs-2 font-bold mb-5">€149/mese</p>
    <button class="btn btn-light btn-lg px-5 py-3 fs-4">
      <i class="fas fa-arrow-right me-2"></i>Passa a GOLD
    </button>
  </div>
</ng-template>

<!-- PLATINO Templates -->
<ng-template #platinoStory1>
  <div class="story-content text-center p-5">
    <div class="story-icon mb-4">
      <i class="fas fa-star fa-5x text-info"></i>
    </div>
    <h2 class="fw-bold mb-4">Piano PLATINO</h2>
    <p class="fs-3 mb-3">Il massimo livello, per chi vuole un percorso su misura</p>
    <p class="fs-4 text-white-50">Esclusivo e personalizzato</p>
  </div>
</ng-template>

<ng-template #platinoStory2>
  <div class="story-content text-center p-5">
    <div class="story-icon mb-4">
      <i class="fas fa-infinity fa-3x text-info mb-4"></i>
    </div>
    <h3 class="fw-bold fs-2 mb-4">Cosa include:</h3>
    <ul class="list-unstyled fs-4 text-start" style="max-width: 600px; margin: 0 auto;">
      <li class="mb-3"><i class="fas fa-check text-info me-3"></i>Tutto del piano GOLD</li>
      <li class="mb-3"><i class="fas fa-check text-info me-3"></i>Consulenza individuale dedicata</li>
      <li class="mb-3"><i class="fas fa-check text-info me-3"></i>Strategia personalizzata su misura</li>
      <li class="mb-3"><i class="fas fa-check text-info me-3"></i>Accesso illimitato a tutti i servizi</li>
      <li class="mb-3"><i class="fas fa-check text-info me-3"></i>Account manager dedicato</li>
      <li class="mb-3"><i class="fas fa-check text-info me-3"></i>Incontri mensili one-to-one</li>
      <li class="mb-3"><i class="fas fa-check text-info me-3"></i>Supporto H24/7</li>
    </ul>
  </div>
</ng-template>

<ng-template #platinoStory3>
  <div class="story-content text-center p-5">
    <div class="story-icon mb-4">
      <i class="fas fa-vip fa-5x text-info"></i>
    </div>
    <h2 class="fw-bold mb-4">L'Eccellenza ti Aspetta</h2>
    <p class="fs-3 mb-3">Piano PLATINO</p>
    <p class="fs-2 font-bold mb-5">Su Misura</p>
    <button class="btn btn-light btn-lg px-5 py-3 fs-4">
      <i class="fas fa-phone me-2"></i>Contattaci
    </button>
  </div>
</ng-template>

